import { useLocation } from 'react-router-dom';
import { useUpdateEffect } from './useUpdateEffect';

export const usePathNameChanged = (effect) => {
  const { pathname } = useLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useUpdateEffect(effect, [pathname]);
};
